import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingPostingResource } from "@exonn/js-sdk";

export const module: ModuleOptions<AccountingPostingResource> = {
  resource: ResourceEnum.AccountingPosting,
  bigIcon: <span className={"icon-20-reservation"} />,
  smallIcon: <span className={"icon-15-reservation"} />,
  list: {
    hideDeleteAction: (row) => {
      return row.is_blocked;
    },
  },
  tabs: {
    edit: {
      titleProp: "number",
    },
  },
};
